import { Component, OnInit } from '@angular/core';
import {GlobalServices} from '../global.services';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  parent = 'sec2a';

  public productSchema: any = {
    '@context': 'https://schema.org',
    '@type': 'Corporation',
    name: 'My TripWell',
    url: 'https://www.mylifewell.com/',
    logo: 'https://www.mylifewell.com/assets/images/logo.png'
  };

  constructor(private globalService: GlobalServices, private title: Title, private meta: Meta) {
    if (this.globalService.isBrowser) {
      this.updateTitle('About MyLIfeWell - Your Source for Living, Traveling & Shopping Well');
      this.updateDescription("Learn about MyLifeWell's vision for a healthy lifestyle: Live Well, Travel Well, and Shop Well. Discover our mission to improve wellness around the globe.");
    }
  }


  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc })
  }
  
  ngOnInit() {
    if (this.globalService.isBrowser) {
      this.loadScript();
        this.globalService?.hideHeader.next(false);
        this.globalService?.hideFooter.next(false);
    }
  }
  ngAfterViewInit() {
    this.globalService.scroller();
  }

  loadScript() {
    if (this.globalService.isBrowser) {
      document.querySelectorAll('script').forEach(el => {
        if (el.getAttribute('type') === 'application/ld+json') {
          el.remove();
        }
      });
      const node = document.createElement('script');
      node.innerHTML = '{\n' +
        '    "@context": "https://schema.org",\n' +
        '      "@type": "Corporation",\n' +
        '      "name": "My TripWell",\n' +
        '      "url": "https://www.mylifewell.com/",\n' +
        '      "logo": "https://www.mylifewell.com/assets/images/logo.png"\n' +
        '  }';
      node.type = 'application/ld+json';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
